import React, { Component } from "react";
import { Button, Col, Row, Card, Form } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

export default class ZunoNominee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      forgotPasswordCondition: false,
      // chpiId: sessionStorage.getItem("chpiId"),
      chpiId: 3290,
      proposalId: sessionStorage.getItem("proposalId"),
      policyuuid: sessionStorage.getItem("policyId"),
      // baseproductId: sessionStorage.getItem("baseproductId"),
      requestIdpropsalone: sessionStorage.getItem("requestIdpropsal"),
      baseproductId: "Supremo",
      cqrId: sessionStorage.getItem("cqrId"),
      nominess: [],
      relations: [],
      tab1Data: {
        name: "",
        dob: "",
        relation: "",
        mobile: "",
        bankAccountNumber: "",
        bankIFSCCode: "",
        clname: "",
        appintname: "",
        adob: null,
        nrelation: "",
        gname: "",
        cmname: "",
      },
      minDate: "",
      maxDate: "",
      Zunoleadsdata: [],
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleInputChange = (tab, field, value) => {
    this.setState((prevState) => ({
      [tab]: {
        ...prevState[tab],
        [field]: value,
      },
    }));
  };
  handleInputMChange = (tab, field, value) => {
    if (tab === "tab1Data" && field === "firstName") {
      // Allow letters and spaces in the name, including an empty value
      const lettersAndSpacesRegex = /^[A-Za-z\s]*$/;
      if (!lettersAndSpacesRegex.test(value.trim())) {
        toast.error("Not allowed special characters and Numbers.");
        return; // Stop further processing for this field
      }
    }
    if (tab === "tab1Data" && field === "lastName") {
      // Allow letters and spaces in the name, including an empty value
      const lettersAndSpacesRegex = /^[A-Za-z\s]*$/;
      if (!lettersAndSpacesRegex.test(value.trim())) {
        toast.error("Not allowed special characters and Numbers.");
        return; // Stop further processing for this field
      }
    }
    var error = "no";
    if (value.length < 1 || value.length > 10) {
      error = "yes";
      toast.error("Please enter valid mobile number.");
    }
    if (error !== "yes") {
      this.setState((prevState) => ({
        [tab]: {
          ...prevState[tab],
          [field]: value,
        },
      }));
    }
  };
  validateForm() {
    const { tab1Data } = this.state;
    const currentDate = new Date();
    const maxDate = new Date();
    maxDate.setFullYear(currentDate.getFullYear() - 98);
    let formIsValid = true;
    if (!tab1Data["salutation"]) {
      formIsValid = false;
      toast.error("Please Select Salutation.");
    } else if (!tab1Data["name"]) {
      formIsValid = false;
      toast.error("Please Enter Nominee Name.");
    } else if (tab1Data["name"].length > 50) {
      formIsValid = false;
      toast.error("Please Enter Name Should 50 Characters.");
    } else if (!tab1Data["clname"]) {
      formIsValid = false;
      toast.error("Please Enter Nominee Last Name.");
    } else if (tab1Data["clname"].length > 50) {
      formIsValid = false;
      toast.error("Please Enter Name Should 50 Characters.");
    } else if (!tab1Data["dob"]) {
      formIsValid = false;
      toast.error("Please Enter DateofBirth.");
    } else if (!tab1Data["nrelation"]) {
      formIsValid = false;
      toast.error("Please Select Nominee Relation.");
    } else {
      const dob = new Date(tab1Data["dob"]);

      // Check if DOB is more than 99 years ago or if it's tomorrow's date
      if (dob >= currentDate || dob <= maxDate) {
        formIsValid = false;
        toast.error(
          "Invalid Date of Birth. Age must be below 98 years and not tomorrow's date."
        );
      }
    }
    return formIsValid;
  }
  handleSubmitBackClick = (e) => {
    window.location.href = "/zunomedical";
  };
  handleSubmitNextClick = (e) => {
    e.preventDefault();
    // if (this.validateForm()) {
    var fd = new FormData();
    const { dob, adob } = this.state.tab1Data;
    const formattedDob = dob ? format(dob, "yyyy-MM-dd") : "";
    const formattedAdob = adob ? format(adob, "yyyy-MM-dd") : "";
    fd.append("proposalId", this.state.proposalId);
    fd.append("baseproductId", this.state.baseproductId);
    fd.append("name", this.state.tab1Data.name);
    fd.append("dob", formattedDob);
    fd.append("relation", this.state.tab1Data.relation);
    fd.append("appintname", "");
    fd.append("adob", formattedAdob);
    fd.append("nrelation", this.state.tab1Data.nrelation);
    fd.append("gname", this.state.tab1Data.gname);
    fd.append("mobile", this.state.tab1Data.mobile);
    fetch(configData.api_url + "rg_Leads/updatenominee/", {
      method: "POST",
      headers: {},
      mode: "cors",
      body: fd, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //window.location.href = "/policieskycform";
          //this.createPolicy();
          this.apisfetchHandler();
          setTimeout(() => {
            this.onSubmitTest();
          }, 1000);
          //
        }
      });
    // }
  };
  onSubmitTest = (e) => {
    const leadszunodata = this.state.Zunoleadsdata;
    const nominee = leadszunodata.nominee || {};
    //insured members
    const insuredMembersString = sessionStorage.getItem("insuredMembers");
    const insuredMembers = insuredMembersString
      ? JSON.parse(insuredMembersString)
      : [];
    // Get policyData from sessionStorage
    const policyDataString = sessionStorage.getItem("policyData");
    const policyData = policyDataString ? JSON.parse(policyDataString) : {};
    console.log("Insured Members from session:", insuredMembers);
    console.log("Policy Data from session:", policyData);
    const memberData = leadszunodata.members.map((member, index) => {
      const medQuestions = member.medicalqns || [];
      const correspondingInsuredMember = insuredMembers[index];
      const medicalData = medQuestions.map((q) => ({
        familyMemberId:
          correspondingInsuredMember?.memberId || member.lhmId || null,
        questionId: parseInt(q.csmqId) || null,
        answerId: isNaN(parseInt(q.ans)) ? null : parseInt(q.ans),
        isAnswered: !!q.ans,
        otherAnswers: q.questionCode === "otherAnswers" ? q.ans : null,
        treatmentAnswers: null,
      }));

      return {
        // id: member.lhmId || null,
        id: correspondingInsuredMember?.memberId || member.lhmId || null,
        // type: member.relation ? member.relation.toLowerCase() : null,
        type: (() => {
          const map = {
            spse: "spouse",
            fath: "father",
            moth: "mother",
            sonm: "son",
            udtr: "daughter",
            flaw: "father-in-law",
            mlaw: "mother-in-law",
          };
          const rel = member.relation ? member.relation.toLowerCase() : null;
          return map[rel] || rel;
        })(),
        dob: member.dob ? member.dob.split(" ")[0] : null,
        sumInsured: parseInt(correspondingInsuredMember?.PACoverAmount) || 0,
        name: `${member.fname} ${member.lname}`.trim(),
        gender: member.gender ? member.gender.toLowerCase() : null,
        height: parseInt(member.height) || null,
        weight: parseInt(member.weight) || null,
        bloodGroup: "B+" || null,
        nomineeName: nominee.name || null,
        nomineeRelation: nominee.nrelation || null,
        nomineeDob: nominee.dob || null,
        appointeeName: nominee.appintname || null,
        appointeeDob: nominee.adob || null,
        appointeeRelationshipWithNominee: nominee.relation || null,
        occupationId: parseInt(member.profession) || null,
        paCoverFileId: member.paCoverFileId || null,
        medicalReportFileId: member.medicalReportFileId || null,
        bmi: member.bmi || null,
        medicalData,
      };
    });
    const proposerDetails = {
      name: leadszunodata.fname || null,
      dob: leadszunodata.dob || null,
      type: "self",
      mobileNumber: leadszunodata.mobile,
      email: leadszunodata.emailId || null,
      gender: leadszunodata.gender || null,
      panNumber: null,
      aadharNumber: null,
      occupationType: null,
      occupation: null,
      nationality: null,
      income: null,
    };
    const addressDetails = leadszunodata.address.map((addressItem) => ({
      type: addressItem.addresstype
        ? addressItem.addresstype.toLowerCase()
        : null,
      isCorrespondencePermanentSame: true,
      address: addressItem.line1 || null,
      pincode: addressItem.pincode || null,
      city: addressItem.cityCd || null,
      state: addressItem.stateCd || null,
      zone:
        policyData?.zone != null
          ? String(policyData.zone)
          : addressItem.zone != null
          ? String(addressItem.zone)
          : null,
    }));
    const jsonData = {
      sourceId: "6128058a-3ff6-4e38-b712-9ed1b8d1d52e",
      policyData: {
        uuid: this.state.policyuuid,
      },
      memberData,
      proposerDetails,
      addressDetails,
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 344);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData1));

    //formData.append("jsonData", this.state.jsonData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("testapidata", JSON.stringify(data.result)); // Storing entire result object
          // sessionStorage.setItem(
          //   "responseData",
          //   JSON.stringify(data.result.data)
          // );
          this.setState({ isSuccess: true });
          sessionStorage.setItem("requestIdpropsal", data.requestId);
          setTimeout(() => {
            this.createPolicysproposal();
          }, 30000);
        }
      });
    //window.location.href = "/zunoquotes";
  };
  createPolicysproposal = (e) => {
    var formData = new FormData();
    const latestRequestId = sessionStorage.getItem("requestIdpropsal");
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 344);
    formData.append("requestId", latestRequestId);
    console.log(latestRequestId);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Full API Response:", data); // Debug log

        if (data.status === "success" && data.data) {
          if (data.data.code === 200) {
            this.showToast("Policy retrieved successfully!", "success");
            setTimeout(() => {
              this.handleSubmitnextoneClick();
            }, 200);
          }
          this.setState({
            quotes: data.data,
          });

          // Correct path based on your API response: data.data.data.policyData.premium
          if (
            data.data &&
            data.data.data &&
            data.data.data.policyData &&
            data.data.data.policyData.premium
          ) {
            const premiumData = data.data.data.policyData.premium;
            const totalAmount = premiumData.totalAmount;
            const basePremium = premiumData.basePremium;
            const gstAmount = premiumData.igstAmount;
            const coverageAmount = premiumData.coverageAmount;
            const discountAmount = premiumData.discountAmount;
            const addonTotal = premiumData.addonTotal;

            // Store individual premium values
            sessionStorage.setItem("totalAmount", totalAmount.toString());
            sessionStorage.setItem("basePremium", basePremium.toString());
            sessionStorage.setItem("gstAmount", gstAmount.toString());
            sessionStorage.setItem("coverageAmount", coverageAmount.toString());
            sessionStorage.setItem("discountAmount", discountAmount.toString());
            sessionStorage.setItem("addonTotal", addonTotal.toString());
            // Store entire premium object
            sessionStorage.setItem("premiumData", JSON.stringify(premiumData));

            // Store proposal identifier
            if (data.data.data.policyData.proposalIdentifier) {
              sessionStorage.setItem(
                "proposalIdentifier",
                data.data.data.policyData.proposalIdentifier
              );
            }

            // Store policy unique ID
            if (data.data.data.policyData.policyUniqueId) {
              sessionStorage.setItem(
                "policyUniqueId",
                data.data.data.policyData.policyUniqueId
              );
            }

            console.log("Total amount stored in session:", totalAmount);
            console.log("Premium data stored successfully:", premiumData);
          } else {
            console.log("Premium data not found in response");
            console.log("Available data structure:", data.data);
          }
        } else {
          console.log("API response unsuccessful or no data");
        }
      })
      .catch((error) => {
        console.error("Error fetching policy proposal:", error);
      });
  };
  handleSubmitnextoneClick = (e) => {
    window.location.href = "/zunoKycpage";
  };
  componentDidMount() {
    const minDate = new Date();
    const dob = new Date(this.state.tab1Data.dob);
    const maxDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 18);
    maxDate.setFullYear(maxDate.getFullYear() - 98);
    const isAbove18 = dob <= minDate;
    this.setState((prevState) => ({
      minDate: maxDate,
      // maxDate: minDate,
      tab1Data: {
        ...prevState.tab1Data,
        // mobile: isAbove18 ? prevState.tab1Data.mobile : "",
        // adob: isAbove18 ? prevState.tab1Data.adob : null,
        mobile: isAbove18 ? "" : prevState.tab1Data.mobile,
        adob: isAbove18 ? null : prevState.tab1Data.adob,
        gname: isAbove18 ? "" : prevState.tab1Data.gname,
        relation: isAbove18 ? "" : prevState.tab1Data.relation,
      },
    }));
    //this.setState({ minDate: maxDate, maxDate: minDate });
    this.HealthnomineerelationsfetchHandler();
    this.relationfetchHandler();
    this.apisfetchHandler();
  }
  apisfetchHandler = () => {
    var formData = new FormData();
    formData.append("proposalId", this.state.proposalId);
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "leads/getleaddetails/", {
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          const { tab1Data } = this.state;
          this.setState({ Zunoleadsdata: data.lead });
          // Validate and handle dob
          let dob = null;
          let adob = null;
          if (
            data.lead.nominee.dob !== "0000-00-00" &&
            !isNaN(Date.parse(data.lead.nominee.dob))
          ) {
            dob = new Date(data.lead.nominee.dob);
          }
          if (
            data.lead.nominee.adob !== "0000-00-00" &&
            !isNaN(Date.parse(data.lead.nominee.adob))
          ) {
            adob = new Date(data.lead.nominee.adob);
          }
          this.setState({ members: data.lead.members });
          this.setState({
            members: data.lead.members,
            tab1Data: {
              ...tab1Data,
              salutation: data.lead.nominee.salutation,
              name: data.lead.nominee.name,
              // clname: data.lead.nominee.lastName,
              dob: dob,
              mobile: data.lead.nominee.mobile,
              relation: data.lead.nominee.relation,
              nrelation: data.lead.nominee.nrelation,
              appintname: data.lead.nominee.appintname,
              adob: adob,
            },
          });
        }
      });
  };
  HealthnomineerelationsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "C_Healthnomineerelations/listByid/", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ nominess: data.list });
        }
      });
  };
  relationfetchHandler = () => {
    var formData = new FormData();
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "C_Healthrelationcodes/listByid/", {
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          this.setState({ relations: data.list });
        }
      });
  };
  render() {
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0); // Set the month to January
    previousYearStart.setDate(1);
    const endYear = new Date();
    endYear.setFullYear(endYear.getFullYear() + 10);
    const { dob } = this.state.tab1Data;
    const isAbove18 = dob && new Date().getFullYear() - dob.getFullYear() <= 18;
    return (
      <div>
        <h1>ZunoNominee</h1>
        <Row id="MainRoOne">
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        className="bi bi-person-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Addon's</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        className="bi bi-person-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Proposer Info</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        className="bi bi-person-vcard-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Member Info</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        onClick={this.handleSubmitBackClick}
                        className="bi bi-heart-pulse"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6
                        style={{ color: "#3d5a95" }}
                        onClick={this.handleSubmitBackClick}
                      >
                        Medicals
                      </h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        className="bi bi-pencil-square"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Nominee Details</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span className="bi bi-arrow-right" id="inActiveArrow"></span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Card>
          <Card.Body>
            <Row>
              <Col md="4" lg="4">
                <Form.Group className="form-group">
                  <Form.Label className="control-label bi bi-star-fill">
                    Nominee&nbsp;Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    id="name"
                    value={this.state.tab1Data.name}
                    onChange={(e) =>
                      this.handleInputChange("tab1Data", "name", e.target.value)
                    }
                    className="form-control"
                    aria-describedby="enterName"
                    placeholder="Enter Nominee Name"
                  />
                </Form.Group>
              </Col>
              <Col md="4" lg="4">
                <Form.Group className="form-group">
                  <Form.Label className="control-label bi bi-star-fill">
                    Nominee Relationship
                  </Form.Label>
                  <Form.Select
                    name="nrelation"
                    value={this.state.tab1Data.nrelation}
                    onChange={(e) =>
                      this.handleInputChange(
                        "tab1Data",
                        "nrelation",
                        e.target.value
                      )
                    }
                    className="form-control"
                    id="nrelation"
                  >
                    <option>Nominee</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Others">Others</option>
                    {this.state.nominess.map((quote, index) => (
                      <option key={index} value={quote.nomineerelation}>
                        {quote.nomineerelation}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md="4" lg="4">
                <Form.Label className="control-label bi bi-star-fill">
                  Nominee&nbsp;DOB
                </Form.Label>
                <Form.Group className="form-group">
                  <div>
                    <DatePicker
                      name="dob"
                      dateFormat="dd/MM/yyyy"
                      showTimeSelect={false}
                      selected={this.state.tab1Data.dob}
                      onChange={(date) =>
                        this.handleInputChange(
                          "tab1Data",
                          "dob",
                          date // Date object
                        )
                      }
                      className="form-control rginomineedob"
                      id="dob"
                      placeholderText="Date of Birth"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={previousYearStart}
                      //minDate={this.state.minDate} // Set the minimum selectable date
                      //maxDate={this.state.maxDate}
                      maxDate={new Date()}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="4" lg="4">
                <Form.Group className="form-group">
                  <Form.Label className="control-label">
                    Appointee Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="appintname"
                    id="appintname"
                    value={this.state.tab1Data.appintname}
                    onChange={(e) =>
                      this.handleInputChange(
                        "tab1Data",
                        "appintname",
                        e.target.value
                      )
                    }
                    className="form-control"
                    aria-describedby="enterName"
                    placeholder="Enter Appointee Name"
                    disabled={!isAbove18}
                  />
                </Form.Group>
              </Col>
              <Col md="4" lg="4">
                <Form.Label className="control-label">Appointee DOB</Form.Label>
                <Form.Group className="form-group">
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    showTimeSelect={false}
                    selected={this.state.tab1Data.adob}
                    onChange={(date) =>
                      this.handleInputChange(
                        "tab1Data",
                        "adob",
                        date // Date object
                      )
                    }
                    className="form-control rginomineedob"
                    id="adob"
                    placeholderText="Date of Birth"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={this.state.minDate} // Set the minimum selectable date
                    maxDate={this.state.maxDate}
                    disabled={!isAbove18}
                  />
                </Form.Group>
              </Col>
              <Col md="4" lg="4">
                <Form.Group className="form-group">
                  <Form.Label className="control-label">
                    Appointee Relationship with Nominee
                  </Form.Label>
                  <Form.Select
                    name="relation"
                    value={this.state.tab1Data.relation}
                    onChange={(e) =>
                      this.handleInputChange(
                        "tab1Data",
                        "relation",
                        e.target.value
                      )
                    }
                    className="form-control"
                    id="relation"
                    disabled={!isAbove18}
                  >
                    <option>Relation ship</option>
                    {this.state.relations.map((quote, index) => (
                      <option key={index} value={quote.relation}>
                        {quote.relation}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <br />

        <Row className="mt-5">
          <Col>
            {" "}
            <Button
              id="getQuotes4"
              onClick={this.handleSubmitBackClick}
              type="submit"
              style={{ float: "left" }}
            >
              Back
            </Button>
          </Col>
          <Col>
            {" "}
            <Button
              id="getQuotes4"
              onClick={this.handleSubmitNextClick}
              type="submit"
              style={{ float: "right" }}
            >
              Next
            </Button>
          </Col>
          {/* </Form> */}
        </Row>
        {/* <Row className="mt-5">
          <Col>
            {" "}
            <Button
              id="getQuotes4"
              onClick={this.handleSubmitnextoneClick}
              type="submit"
              style={{ float: "right" }}
            >
              Kyc
            </Button>
          </Col>
        </Row> */}
      </div>
    );
  }
}
